var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FEF7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2074 15.1272L13.2081 15.1277C13.4551 15.3204 13.7598 15.4253 14.0737 15.4255C14.3874 15.4258 14.6922 15.3214 14.9395 15.1292L13.2074 15.1272ZM13.2074 15.1272L5.85316 9.49298L5.85316 9.37547C5.85316 9.37546 5.85316 9.37544 5.85316 9.37542C5.85348 9.10373 5.96198 8.84318 6.15499 8.65094C6.34803 8.45867 6.60984 8.35045 6.88301 8.35014H21.117C21.117 8.35014 21.117 8.35014 21.117 8.35014C21.3902 8.35047 21.652 8.45869 21.845 8.65094C22.038 8.84319 22.1465 9.10376 22.1468 9.37547V9.49501L14.9397 15.1291L13.2074 15.1272ZM21.1173 7.4H21.1171L6.88289 7.4L6.88278 7.4C6.35723 7.4006 5.85329 7.6088 5.48155 7.97905C5.10979 8.34932 4.9006 8.85143 4.9 9.37525V9.37536L4.9 18.6246L4.9 18.6248C4.9006 19.1486 5.10979 19.6507 5.48155 20.0209C5.85329 20.3912 6.35723 20.5994 6.88278 20.6H6.88289H21.1171H21.1172C21.6428 20.5994 22.1467 20.3912 22.5185 20.0209C22.8902 19.6507 23.0994 19.1486 23.1 18.6248V18.6246V9.37536V9.37525C23.0994 8.85144 22.8902 8.34932 22.5185 7.97905C22.1467 7.60878 21.6428 7.40059 21.1173 7.4ZM15.5263 15.8778L15.5265 15.8777L17.1645 14.5975L21.9513 19.2252C21.864 19.3454 21.7513 19.4456 21.6208 19.5186C21.4669 19.6045 21.2935 19.6498 21.1171 19.6499H6.88295C6.70708 19.6498 6.53417 19.6048 6.38071 19.5193C6.25102 19.4471 6.13887 19.348 6.05165 19.229L10.9751 14.6155L12.6237 15.8785C12.6238 15.8786 12.6239 15.8787 12.624 15.8788C13.0386 16.2011 13.5494 16.3762 14.0752 16.376C14.6011 16.3759 15.1119 16.2005 15.5263 15.8778ZM17.9215 14.0055L22.1469 10.7024V18.0908L17.9215 14.0055ZM10.2095 14.0287L5.85316 18.1109V10.6913L10.2095 14.0287Z",
    fill: "#EFAE08",
    stroke: "#EFAE08",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampMail);
export default __webpack_public_path__ + "static/media/campMail.b23d3f201e14c0c7dcd29c1b757cdbf5.svg";
export { ForwardRef as ReactComponent };